import { IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import React from "react";

interface ManualModeButtonProps {
  onSwitchToManual: () => void;
}

export default function ManualModeButton({
  onSwitchToManual,
}: ManualModeButtonProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        onClick={onSwitchToManual}
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          "&:hover": {
            backgroundColor: "primary.dark",
          },
        }}
      >
        <ExitToAppIcon />
      </IconButton>
    );
  }

  return (
    <Tooltip title="Manual Mode" arrow>
      <IconButton
        aria-label="switch to manual mode"
        size="large"
        color="inherit"
        onClick={onSwitchToManual}
      >
        <ExitToAppIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}
